<div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
    <div class="bg-surface-0 rounded-2xl shadow-lg px-4 py-4 lg:px-6 lg:py-5 h-full flex flex-col">
        <div class="flex flex-col gap-3 mb-4">
            <div class="flex flex-col md:flex-row md:items-start md:justify-between gap-3">
                <div class="flex flex-col gap-1">
                    <h2 class="text-sm mb-0 font-semibold text-slate-900">
                        @if (cascadeView === 'cascade') {
                        Cascade of Care
                        } @else {
                        Scenario Trends
                        }
                    </h2>

                    <p class="text-[11px] text-slate-500">
                        @if (cascadeView === 'cascade') {
                        @if (selectedCascadeSimulation === 'Basic Simulation') {
                        Basic Simulation Year {{ projectedYear }}
                        } @else {
                        Basic Simulation vs {{ selectedCascadeSimulation }} Year {{ projectedYear }}
                        }
                        } @else {
                        Compare simulation trajectories over time.
                        }
                    </p>
                </div>

                <div class="inline-flex overflow-hidden rounded-md border border-surface-200 bg-surface-50 self-start">
                    <button type="button" class="px-3 py-1.5 text-xs font-semibold transition-colors"
                        [ngClass]="cascadeView === 'cascade' ? 'bg-[#d41c58] text-white' : 'bg-transparent text-slate-500 hover:text-slate-700'"
                        (click)="setCascadeView('cascade')">
                        Cascade
                    </button>

                    <button type="button" class="px-3 py-1.5 text-xs font-semibold transition-colors"
                        [ngClass]="cascadeView === 'scenarios' ? 'bg-[#d41c58] text-white' : 'bg-transparent text-slate-500 hover:text-slate-700'"
                        (click)="setCascadeView('scenarios')">
                        Scenarios
                    </button>
                </div>
            </div>

            @if (cascadeView === 'scenarios') {
            <div class="flex items-center justify-end gap-2 t3-scenerio-dropdown">
                <p-select [options]="scenarioMetricOptions" [(ngModel)]="scenarioMetric" optionLabel="label"
                    optionValue="value" appendTo="body" placeholder="Metric" class="w-40"
                    (onChange)="onScenarioMetricChange()">
                </p-select>

                <p-select [options]="scenarioGroupOptions" [(ngModel)]="scenarioGroup" optionLabel="label"
                    optionValue="value" appendTo="body" placeholder="Group" class="w-28"
                    (onChange)="onScenarioGroupChange()">
                </p-select>
            </div>
            }
        </div>

        @if (cascadeView === 'cascade') {
        <div class="flex-1 min-h-[300px]">
            <p-chart type="bar" [data]="cascadeData" [options]="cascadeOptions" style="height: 100%; width: 100%">
            </p-chart>
        </div>
        } @else {
        <div class="flex-1 min-h-[250px]">
            <p-chart type="line" [data]="scenarioChartData" [options]="scenarioChartOptions"
                style="height: 100%; width: 100%">
            </p-chart>
        </div>
        }
    </div>

    <div class="bg-surface-0 rounded-2xl shadow-lg overflow-hidden h-full">
        <div class="px-4 py-4 lg:px-6 lg:py-5 border-b border-surface-200">
            <div class="flex items-center justify-between gap-3">
                <div>
                    <h2 class="text-sm font-semibold text-slate-900 mb-0">Projected impact</h2>
                    <p class="text-[11px] text-slate-500 mt-1">
                        @if (selectedInfoSimulation === 'Basic Simulation') {
                        Comparison of Basic Simulation between {{ baselineYear }} and {{ projectedYear }}
                        } @else {
                        Comparison of Basic Simulation vs {{ selectedInfoSimulation }} at year {{ projectedYear }}
                        }
                    </p>
                </div>

                <div class="inline-flex overflow-hidden rounded-md border border-surface-200 bg-surface-50">
                    <button type="button" class="px-3 py-1.5 text-xs font-semibold transition-colors"
                        [ngClass]="htCvdView === 'ht' ? 'bg-[#d41c58] text-white' : 'bg-transparent text-slate-500 hover:text-slate-700'"
                        (click)="htCvdView = 'ht'">
                        HT
                    </button>

                    <button type="button" class="px-3 py-1.5 text-xs font-semibold transition-colors"
                        [ngClass]="htCvdView === 'cvd' ? 'bg-[#d41c58] text-white' : 'bg-transparent text-slate-500 hover:text-slate-700'"
                        (click)="htCvdView = 'cvd'">
                        CVD
                    </button>
                </div>
            </div>
        </div>

        @if (htCvdView === 'ht') {
        <div class="divide-y divide-surface-200">
            @for (item of htImpactRows; track item.key) {
            <div class="px-4 py-3 lg:px-6 flex items-center gap-3">
                <div class="h-10 w-10 rounded-full bg-rose-50 text-rose-600 flex items-center justify-center">
                    <i [ngClass]="item.icon" class="text-sm"></i>
                </div>

                <div class="flex-1">
                    <div class="text-sm font-semibold text-slate-900">{{ item.title }}</div>
                    <div class="text-[11px] text-slate-500 mt-0.5">
                        <span class="font-semibold text-slate-700">{{ format(item.row.baseline) }}</span>
                        <span class="mx-1 text-slate-400">→</span>
                        <span class="font-semibold text-slate-700">{{ format(item.row.new) }}</span>
                    </div>
                </div>

                <div class="text-right">
                    <div class="inline-flex items-center gap-1 text-xs font-semibold"
                        [class.text-emerald-600]="item.row.deltaPct > 0" [class.text-rose-600]="item.row.deltaPct < 0"
                        [class.text-slate-500]="item.row.deltaPct === 0">
                        <i class="pi" [class.pi-sort-up-fill]="item.row.deltaPct > 0"
                            [class.pi-sort-down-fill]="item.row.deltaPct < 0"
                            [class.pi-minus]="item.row.deltaPct === 0">
                        </i>
                        <span>{{ item.row.deltaPct }}%</span>
                    </div>

                    <div class="text-[11px] font-semibold" [class.text-emerald-600]="item.row.deltaAbs > 0"
                        [class.text-rose-600]="item.row.deltaAbs < 0" [class.text-slate-500]="item.row.deltaAbs === 0">
                        {{ format(item.row.deltaAbs) }}
                    </div>
                </div>
            </div>
            }
        </div>

        <div class="px-4 py-3 lg:px-6 bg-surface-50 text-[11px] text-slate-500">
            <span class="font-semibold text-slate-700">Note:</span>
            {{ htNote }}
        </div>
        } @else {
        <div class="divide-y divide-surface-200">
            @for (item of cvdSummary; track item.id) {
            <div class="px-4 py-3 lg:px-6 flex items-center gap-3">
                <div class="h-10 w-10 rounded-full bg-slate-50 text-slate-600 flex items-center justify-center">
                    <i [ngClass]="item.iconClass" class="text-sm"></i>
                </div>

                <div class="flex-1">
                    <div class="text-sm font-semibold text-slate-900">{{ item.title }}</div>
                    <div class="text-[11px] text-slate-500 mt-0.5">
                        <span class="font-semibold text-slate-700">{{ format(item.baseline) }}</span>
                        <span class="mx-1 text-slate-400">→</span>
                        <span class="font-semibold text-slate-700">{{ format(item.projected) }}</span>
                    </div>
                </div>

                <div class="text-right">
                    <div class="inline-flex items-center gap-1 text-xs font-semibold"
                        [class.text-emerald-600]="item.deltaPct > 0" [class.text-rose-600]="item.deltaPct < 0"
                        [class.text-slate-500]="item.deltaPct === 0">
                        <i class="pi" [class.pi-sort-up-fill]="item.deltaPct > 0"
                            [class.pi-sort-down-fill]="item.deltaPct < 0" [class.pi-minus]="item.deltaPct === 0">
                        </i>
                        <span>{{ item.deltaPct }}%</span>
                    </div>

                    <div class="text-[11px] font-semibold" [class.text-emerald-600]="item.deltaAbs > 0"
                        [class.text-rose-600]="item.deltaAbs < 0" [class.text-slate-500]="item.deltaAbs === 0">
                        {{ format(item.deltaAbs) }}
                    </div>
                </div>
            </div>
            }
        </div>

        <div class="px-4 py-3 lg:px-6 bg-surface-50 text-[11px] text-slate-500">
            <span class="font-semibold text-slate-700">Note:</span>
            {{ cvdNote }}
        </div>
        }
    </div>
</div>